import {
  ROUTE_MEDICATION,
  ROUTE_MEDICATION_SEARCH,
  ROUTE_MEDICATION_STATUS,
  ROUTE_TARIFICATION_ATTEST,
  ROUTE_TARIFICATION_EFACT,
  ROUTE_TARIFICATION_FINISH,
  ROUTE_TARIFICATION_NOM,
  ROUTE_TARIFICATION_PATIENT,
  ROUTE_TARIFICATION_PAYMENT,
  ROUTE_TIMELINE,
} from "routes.global";

export const PV_PATIENT_SEARCH = { documentTitle: "patientSearch" };

export const PV_TIMELINE = { documentTitle: "timeline", href: ROUTE_TIMELINE };

export const PV_MEDICATION_OVERVIEW = {
  documentTitle: "medicationOverview",
  href: ROUTE_MEDICATION,
};
export const PV_MEDICATION_SEARCH = {
  documentTitle: "medicationSearch",
  href: ROUTE_MEDICATION_SEARCH,
};
export const PV_MEDICATION_STATUS = {
  documentTitle: "medicationStatus",
  href: ROUTE_MEDICATION_STATUS,
};

export const PV_NOMENCLATURE_CODE = {
  documentTitle: "nomenclatureCode",
  href: ROUTE_TARIFICATION_NOM,
};
export const PV_PATIENT_TYPE = {
  documentTitle: "patientType",
  href: ROUTE_TARIFICATION_PATIENT,
};
export const PV_EFACT_EATTEST = {
  documentTitle: "eFactEAttest",
  href: ROUTE_TARIFICATION_EFACT,
};
export const PV_CO_PAYMENT = {
  documentTitle: "coPayment",
  href: ROUTE_TARIFICATION_PAYMENT,
};
export const PV_ATTESTATION = {
  documentTitle: "attestation",
  href: ROUTE_TARIFICATION_ATTEST,
};
export const PV_PAYMENT = {
  documentTitle: "payment",
  href: ROUTE_TARIFICATION_PAYMENT,
};

export const PV_CONSULTATION_FINISHED = {
  documentTitle: "consultationFinished",
  href: ROUTE_TARIFICATION_FINISH,
};
